export default "__VITE_ASSET__CZekQClq__"